@if (incomeTaxEntity$ | async) {
    <form [formGroup]="loonVroegerFg">
        @if (loonVroegereArbeid.length > 0) {
            <div formArrayName="loonVroegereArbeid">
                @for (item of loonVroegereArbeid.controls; track item; let i = $index) {
                    <div [formGroupName]="i" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                        <div class="col-auto row" formGroupName="loon" style="--bs-gutter-x: 0.5rem;">
                            <snelstart-ui-text-form-control [label]="i === 0 ? 'Uitkeringsinstantie' : ''"
                                                            class="custom-input-250"
                                                            formControlName="omschrijving"
                                                            id="omschrijving">
                            </snelstart-ui-text-form-control>
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              [label]="i === 0 ? 'Bedrag' : ''"
                                                              [required]="true"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="bedrag"
                                                              id="bedrag"
                                                              prefix="€">
                            </snelstart-ui-number-form-control>
                        </div>
                        @if ((incomeTaxEntity$ | async)?.taxType === "DA") {
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              [label]="i === 0 ? 'Loonheffing' : ''"
                                                              [required]="true"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="loonheffing"
                                                              id="loonheffing"
                                                              prefix="€">
                            </snelstart-ui-number-form-control>

                            <snelstart-ui-select-form-control [label]="i === 0 ? 'Soort uitkering' : ''"
                                                              [options]="optionsLoonsoort"
                                                              class="custom-input-250 col-auto"
                                                              formControlName="loonsoort">
                            </snelstart-ui-select-form-control>
                        }
                        <div class="col-auto">
                            <snelstart-ui-button (click)="verwijderRij(i)"
                                                 [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                                 class="delete"
                                                 icon="trash"
                                                 id="buttonDelete"
                                                 size="medium"
                                                 type="secondary">
                            </snelstart-ui-button>
                        </div>
                        @if (omschrijvingTeVeelKarakters(i)) {
                            <div class="pb-2" style="width: 75%; color: red">
                                Let op: het veld 'Uitkeringsinstantie' mag maximaal 70 karakters bevatten!
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </form>

    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Pensioen/uitkering toevoegen
    </snelstart-ui-button>

    @if (hasLoonsoort11()) {
        <form (change)="saveForm()" [formGroup]="rechtOpAowAlleenstaandeFg">
            <div class="row mb-1 pt-3">
                <div class="col-auto pt-1">
                    @if (this.isPartner) {
                        <p>
                            Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                            in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
                            recht op een AOW-uitkering voor alleenstaanden?</p>
                    } @else {
                        <p>
                            Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                            in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
                            recht op een AOW-uitkering voor alleenstaanden?</p>
                    }
                </div>
                <div class="col-auto">
                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                      [options]="optionsJaNee"
                                                      class="me-1 custom-input-200"
                                                      formControlName="rechtOpAowAlleenstaande">
                    </snelstart-ui-select-form-control>
                </div>
            </div>
        </form>
    }

    @if (hasLoonsoort14()) {
        <form [formGroup]="wajongFg">
            <div class="row mb-1 pt-3">
                <div class="col-auto pt-4 pe-3">
                    @if (isPartner) {
                        <p>
                            Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                            in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
                            recht op de jonggehandicaptenkorting (wajong)?</p>
                    } @else {
                        <p>
                            Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                            in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
                            recht op de jonggehandicaptenkorting (wajong)?</p>
                    }
                </div>
                <div class="col-auto">
                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                      [options]="optionsJaNeeWajong"
                                                      class="me-1 custom-input-225"
                                                      label="Selecteer"
                                                      formControlName="krijgtWajong">
                    </snelstart-ui-select-form-control>
                </div>
            </div>
        </form>
    }

    @if ((incomeTaxEntity$ | async)?.taxType === "DA" && loonVroegereArbeid.length > 1) {
        <snelstart-ui-alert type="info">
            Let op! Bij een verzoek of wijziging voorlopige aanslag wordt de ingehouden loonheffing automatisch
            berekend.<br/>
            Beantwoord hiervoor de volgende vraag 'Meer banen of uitkeringen tegelijk'.
        </snelstart-ui-alert>
    }
}
